import {EmbedType} from "../../../../../core/gd/const/embed/embed-type"
import {EmbedTypeConfigs} from "../../../../../core/gd/const/embed/embed-type-config"
import {PopoverMenuItemType} from "../../../../../core/gd-components/popover-menu/popover-menu/const"

const debug = false
// const debug = "menuAdd_getEmbedOptions"

export default async function menuAdd_getEmbedOptions(projectId: ID | undefined, onAddEmbed: {(embedType: EmbedType):void}): Promise<Option[]> {

    const getItem = (embedType: EmbedType) => {
        const embedTypeConfig: any = EmbedTypeConfigs[embedType]

        debug && console.log(debug, 'process getItem', embedTypeConfig)

        return {
            label   : embedTypeConfig.name,
            icon    : embedTypeConfig.icon,
            onClick : ()=>{onAddEmbed(embedType)}
        }
    }

    const res = _.compact([
        getItem(EmbedType.DEFAULT),

        {type: PopoverMenuItemType.SEPARATOR},

        getItem(EmbedType.FIGMA),
        getItem(EmbedType.GOOGLE_MAP),
        getItem(EmbedType.YOUTUBE),
        getItem(EmbedType.GOOGLE_CALENDAR),
        getItem(EmbedType.GOOGLE_DOC),
        getItem(EmbedType.GOOGLE_SHEET),
        getItem(EmbedType.GOOGLE_SLIDES),
        getItem(EmbedType.FACEBOOK),
        getItem(EmbedType.TWITTER),

    ])

    debug && console.log(debug, 'process res', res)

    return res
}